module.exports = __webpack_public_path__ + "static/media/gc-street-bad.3e785920.png";